import axios from '../library/axiosConfig'
import qs from 'qs'
import userAgentHelper from '../library/userAgentHelper';
let channel = userAgentHelper.channel;

export default {
  showAddBill(data) {
    return axios.post('/renterAccount/v1/showAddBill', data, {baseURL: axios.defaults.saleUrl})
  },
  queryOrderBillTypes(data) {
    return axios.post('/renterAccount/v2/queryOrderBillTypes', data, {baseURL: axios.defaults.saleUrl, json: true})
  },
  addCustomBill(data) {
    return axios.post('/renterAccount/v2/addCustomBill', data, {baseURL: axios.defaults.saleUrl, json: true})
  },
  //该用户是否有有效租约
  hasLease(data) {
    return axios.post('/order/v1/hasLease', data, {baseURL: axios.defaults.saleUrl});
  },
  //  租客发起退房申请
  applyCheckout(data) {
    return axios.post('/order/applyCheckout/v1/applyCheckout', data, {baseURL: axios.defaults.saleUrl})
  },
  //  租客撤销发起退房申请
  cancleApplyCheckout(data) {
    return axios.post('/order/applyCheckout/v1/cancleApplyCheckout', data, {baseURL: axios.defaults.saleUrl})
  },
  //  租客确认退房操作
  confirmCheckout(data) {
    return axios.post('/order/applyCheckout/v1/confirmCheckout', data, {baseURL: axios.defaults.saleUrl})
  },
  //  获取租客发起退房申请信息
  findApplyCheckoutInfo(data) {
    return axios.post('/order/applyCheckout/v1/findApplyCheckoutInfo', data, {baseURL: axios.defaults.saleUrl})
  },
  //  申请出证
  applyCretByQbb(data){
    return axios.post('/order/v1/applyCretByQbb', data, {baseURL: axios.defaults.saleUrl})
  },
  // 查询开通代付状态
  getWithholdStatus (data) {
    return axios.post('/order/v1/getCntrAutoDeductStatus', data, {baseURL: axios.defaults.saleUrl})
  },
  // 开通自动代扣
  openAutoPay (data) {
    return axios.post('/realMonthPay/v1/openAutoPay', data, {baseURL: axios.defaults.saleUrl});
  },
  // 解除自动代扣
  terminateAutoPay (data) {
    return axios.post('/realMonthPay/v1/terminateAutoPay', data, {baseURL: axios.defaults.saleUrl});
  },
  // 获取合同列表
  getRealPayMonthContractList (data) {
    return axios.post('/realMonthPay/v1/getRealPayMonthContractList', data, {baseURL: axios.defaults.saleUrl});
  },
  // 获取月付账单支付计划列表
  getRealPayMonthBillPlanList (data) {
    return axios.post('/realMonthPay/v1/getRealPayMonthBillPlanList', data, {baseURL: axios.defaults.saleUrl});
  },
  getCashierDeskTemporary(data) {
    return axios.post(`/pay/v1/getCashierDeskTemporary?${qs.stringify(data, {allowDots: true})}`, {}, {baseURL: axios.defaults.saleUrl} )
  },
  //支付宝线下支付账单
  aliOfflinePay(data) {
    return axios.post(`/pay/v1/aliOfflinePay`, data, {baseURL: axios.defaults.saleUrl});
  },
  //获取支付宝线下付款的付款码
  getAliOffPayUrl(data) {
    return axios.post(`/pay/v1/getAliOffPayUrl`, data, {baseURL: axios.defaults.saleUrl});
  },
  smartWatermeter(data) {
    return axios.post(`/smart/watermeter/v1/info`, data, {baseURL: axios.defaults.saleUrl, json: true});
  },
  smartWatermeterLog(data) {
    return axios.post(`/smart/watermeter/v1/cacl/log`, data, {baseURL: axios.defaults.saleUrl, json: true});
  },
  // 新增问题时选择租约列表
  getListHasConfirmedRenterOrder(data){
    return axios.post('/order/v1/listHasConfirmedRenterOrder', data, {baseURL: axios.defaults.saleUrl})
  },
  // 根据支付宝交易号获取orderId
  querOrderIdByTradeLogId(data) {
    return axios.post('/pay/v1/querOrderIdByTradeLogId', data, {baseURL: axios.defaults.saleUrl})
  },
  // 查询我可买保险的租约列表
  getInsuranceCanBuyList() {
    return axios.get('/insurance/v1/canBuyList',{baseURL: axios.defaults.saleUrl})
  },
  // 查询我的保险列表
  getInsuranceList() {
    return axios.get('/insurance/v1/list',{baseURL: axios.defaults.saleUrl})
  },
  // 用来统计埋点的
  userRecord(options) {
    let terminalTag = ''

    switch (channel) {
      case 1: // app
        terminalTag = 'renter-app'
        break;
      case 10:
        terminalTag = 'weixin-renter-h5'
        break;
      case 56:
        terminalTag = 'weixin-renter-mini'
        break;
      case 11:
        terminalTag = 'ali-renter-h5'
        break;
      case 57:
        terminalTag = 'ali-renter-mini'
        break;
      default: //其它
        terminalTag = 'renter-h5'
        break;
    }

    let params = Object.assign({
      "logName": null, // page info or method info
      "methodName": "pageView", // click, pageView, etc...
      "terminalTag": terminalTag
    }, options)
    return axios.post('/order/record', params,{baseURL: axios.defaults.saleUrl, json: true})
  }
}



// WEBPACK FOOTER //
// ./src/api/renterembedSale.js